import React, { ComponentProps, FC, ReactNode } from 'react'
import { components } from 'react-select'
import styled from 'styled-components'

export type Props = ComponentProps<typeof components.MenuList> & {
  cannotCreateOptionReason?: ReactNode | null
}

export const CustomMenuList: FC<Props> = props => {
  return (
    <components.MenuList {...props}>
      {props.cannotCreateOptionReason && (
        <CannotCreateOptionReason>{props.cannotCreateOptionReason}</CannotCreateOptionReason>
      )}
      {props.children}
    </components.MenuList>
  )
}

const CannotCreateOptionReason = styled.div`
  padding: 8px 12px;
`

export type CustomMenuListProps = Props
